export const GET_REGIONS = 'Main/GET_REGIONS';
export const REDIRECT = 'Main/REDIRECT';
export const SET_LANGUAGE = 'Main/SET_LANGUAGE';
export const SET_REGION = 'Main/SET_REGION';
export const SET_REGION_FROM_HOST = 'Main/SET_REGION_FROM_HOST';
export const SET_REGION_FROM_STORAGE = 'Main/SET_REGION_FROM_STORAGE';
export const SETUP_REGION = 'Main/SETUP_REGION';
export const SETUP_LANGUAGE = 'Main/SETUP_LANGUAGE';
export const SETUP_USER = 'Main/SETUP_USER';
